<script>
    import {Link} from "svelte-routing";
    
    export let href = '#';
</script>

<Link to={href} class="btn btn-link btn-icon" {...$$restProps}>
    <ion-icon name="arrow-back-outline" role="img" class="md hydrated" aria-label="back"></ion-icon>
</Link>
